<template>
  <div class="h-foot">
    <hr/>
    <div class="icp-info">
      <span>
        <a class="icp-link" href="https://beian.miit.gov.cn" target="_blank">
          桂ICP备2024039520号-1
        </a>
        &nbsp;
         <a class="icp-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=44010602013028" target="_blank">
           <img class="icon" src="@/static/icon/gaba.png">
           <span>粤公网安备44010602013028</span>
         </a>
      </span>
    </div>
    <div class="contact-info">
      <span>&copy; 2024 Tinjeck  版权所有</span>
      <span> 联系邮箱: Tinjeck@163.com</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'h-foot'
}
</script>

<style scoped>
.h-foot {
  padding: 10px;
  font-size: 14px;
}

hr {
  width: 50%;
  margin: 10px auto 20px auto;
  border: none;
  height: 1px;
  background-image: linear-gradient(to right, #ccc, #fff, #ccc);
  border-radius: 2px; /* 圆角效果 */
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /* 轻微的阴影效果 */
}

.icp-info {
  height: 20px;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}

.icp-link {
  text-decoration: none;
  color: inherit;
}

.icp-link:hover {
  color: #06c;
  text-decoration: underline;
  cursor: pointer;
}

.icon {
  width: 20px; /* 设置图标宽度为20px */
  height: 20px; /* 设置图标高度为20px */
  vertical-align: middle; /* 垂直居中对齐 */
  margin-right: 5px; /* 图标和链接文本之间的间距 */
}

.contact-info {
  padding-top: 5px;
}
</style>
